import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../apiSetup/apiCall';

export const fetchPaymentsAndTransactionsData = createAsyncThunk(
  'fetchPaymentsAndTransactionsData',
  async ({  startDate, endDate }) => {
    try {
      const response = await api.get(`prometheus/payement/list/${startDate}/${endDate}/`);
      if (response.data)
        return response.data;
      else
        throw new Error('error')
    } catch (error) {
      console.error('Error fetching logs data:', error);
      throw error;
    }
  }
);
const PaymentsAndTransactionsSlice = createSlice({
  name: 'paymentsAndTransactions',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    setSelectedMonthYear : (state,action)=>{
      state.selectedMonthYear=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentsAndTransactionsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPaymentsAndTransactionsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchPaymentsAndTransactionsData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});
export const {setSelectedMonthYear} = PaymentsAndTransactionsSlice.actions;
export default PaymentsAndTransactionsSlice.reducer;